import { createFileRoute } from "@tanstack/react-router";
import z from "zod";

import { DEFAULT_EMAIL_OVERVIEW_SORT } from "@/constants/email-analytics";
import type { EmailDateRange, EmailOverviewSort } from "@/types/email-analytics";
import { ScreenContent, ScreenHeader, ScreenTitle } from "@/ui";
import { isOverviewSort, resolveOverviewRange } from "@/utils/email-analytics";
import { DeliveryIssuesCard } from "./-components/delivery-issues-card";
import { OverviewCard } from "./-components/overview-card";
import { TrendCard } from "./-components/trend-card";

const NotificationAnalyticsPage = () => {
  const { from, sort, to } = Route.useSearch();
  const navigate = Route.useNavigate();
  const range = resolveOverviewRange(from, to);

  const handleRangeChange = (next: EmailDateRange) => {
    void navigate({
      search: (prev) => {
        return { ...prev, ...next };
      },
    });
  };

  const handleSortChange = (next: EmailOverviewSort) => {
    void navigate({
      search: (prev) => {
        return { ...prev, sort: next };
      },
    });
  };

  return (
    <>
      <ScreenHeader>
        <ScreenTitle>Notification analytics</ScreenTitle>
      </ScreenHeader>

      <ScreenContent>
        <div className="flex flex-col gap-6">
          <TrendCard />

          <OverviewCard
            onRangeChange={handleRangeChange}
            onSortChange={handleSortChange}
            range={range}
            sort={sort ?? DEFAULT_EMAIL_OVERVIEW_SORT}
          />

          <DeliveryIssuesCard />
        </div>
      </ScreenContent>
    </>
  );
};

const DATE_PATTERN = /^\d{4}-\d{2}-\d{2}$/;

export const Route = createFileRoute("/_private/notification-analytics/")({
  component: NotificationAnalyticsPage,
  validateSearch: z.object({
    from: z.string().regex(DATE_PATTERN).optional().catch(undefined),
    to: z.string().regex(DATE_PATTERN).optional().catch(undefined),
    sort: z.custom<EmailOverviewSort>(isOverviewSort).optional().catch(undefined),
  }),
});
